import React, {useState, useEffect} from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {differenceInDays, differenceInYears, parse} from 'date-fns';
import {
    Checkbox, Container,
    FilledInput,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel, MenuItem, Paper, Radio,
    RadioGroup, Select, TextField,
    Typography
} from "@mui/material";
import { DatePicker,MobileDatePicker } from '@mui/x-date-pickers';
import SecondaryButton from "../../Common/SecondaryButton";
import PrimaryButton from "../../Common/PrimaryButton";
import {Form} from "formik";
import {makeStyles} from "@mui/styles";
import "./datePicker.scss";
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {showAlertAutoDis, getCountryList} from "../../../utils/utils";
import {BookingPropTypes} from "../../../utils/PropTypes/BookingPropTypes";

const useStyles = makeStyles((theme) => ({
    sectionTitle: {
        fontSize: '1.6rem',
        fontWeight: '600',
        marginBottom: '10px',
    },
    noteContainer: {
        marginLeft: '10px',
        marginRight: '10px',
        paddingTop: '20px',
        marginBottom: '20px',
    },
    formSection: {
        marginBottom: '20px',
    },
    checkboxLabel: {
        fontSize: '1.4rem',
    },
    infoContainer: {
        backgroundColor: theme.palette.lightBlue.main,
        paddingBottom: '20px',
    },
}));

const PassportAndContactForm = ({values, handleChange, setFieldValue, initialValues}) => {
    const classes = useStyles();
    const [responsive, setResponsive] = useState(false);
    const [displayEnsenadaAlert, setDisplayEnsenadaAlert] = useState(false);
    const countryList = getCountryList();
    const {booking} = useSelector(state => state.bookingForm);
    const disableSexRadioBtn = !!(initialValues.sex);
    const history = useHistory();

    const boardDate = parse(booking.trip.boarddate, 'yyyy-MM-dd', new Date());
    const daysBeforeBoardDate = differenceInDays(boardDate, new Date());
    // const disableInputs = daysBeforeBoardDate < 8;
    const disableInputs = false ;

    useEffect(() => {
        checkResponsive();
        window.addEventListener('resize', checkResponsive, true);
    }, []);

    useEffect(() => {
        if (values?.meetIn === 'Ensenada')
            setDisplayEnsenadaAlert(true);
        else
            setDisplayEnsenadaAlert(false);
    }, [values?.meetIn]);


    const checkResponsive = () => {
        const width = window.innerWidth;
        if (width < 700) setResponsive(true);
        else setResponsive(false);
    };

    const verifyAge = (dob) => {
        if (!dob || booking.trip.location.tripTypeFk === 2) return;

        const age = differenceInYears(new Date(), dob);
        if (age < 15)
            return showAlertAutoDis({
                title: 'Notice',
                text: 'Please contact the Nautilus office for assistance 604-241-1918.',
                manualClose: true
            });
    };

    return (
        <Form>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid container style={{marginTop: '50px'}} sx={{px: {xs: '1.6rem', lg: '0'}}}>
                    <Typography variant="h3" sx={{marginBottom: '20px'}}>
                        Passport Information<span style={{color: 'red'}}>*</span>
                    </Typography>
                    <Grid container spacing={3} className={classes.formSection}>
                        <Grid item xs={12} md={12}>
                            <FormControlLabel control={<Checkbox id="agreement" name="agreement" onChange={handleChange}
                                                                 sx={{width: {xs: '8rem', lg: '4rem'}}}
                                                                 checked={values.agreement}/>}
                                              label={<Typography component="span"
                                                                 className={classes.checkboxLabel}>
                                                  I understand and agree that data collected in this booking
                                                  will be
                                                  protected
                                                  and solely and only used for the purpose of this reservation.
                                                  (Read our <a target="_blank"
                                                               href="https://nautilusliveaboards.com/privacy-policy">Privacy
                                                  Policy</a>)
                                              </Typography>}>
                            </FormControlLabel>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={9}>
                            <Typography variant="h5" className={classes.sectionTitle}>Name</Typography>
                            <Grid container spacing={3} className={classes.formSection}>
                                <Grid item xs={12} md={6}>
                                    <FormControl variant="filled" fullWidth>
                                        <InputLabel htmlFor="firstName">First Name</InputLabel>
                                        <FilledInput id="firstName" name="firstName"
                                                     value={values.firstName}
                                                     disabled={disableInputs}
                                                     onChange={handleChange} disableUnderline/>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl variant="filled" fullWidth>
                                        <InputLabel htmlFor="middleName">Middle Name</InputLabel>
                                        <FilledInput id="middleName" name="middleName"
                                                     value={values.middleName}
                                                     disabled={disableInputs}
                                                     onChange={handleChange} disableUnderline/>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl variant="filled" fullWidth>
                                        <InputLabel htmlFor="lastName">Last Name</InputLabel>
                                        <FilledInput id="lastName" name="lastName"
                                                     value={values.lastName}
                                                     disabled={disableInputs}
                                                     onChange={handleChange} disableUnderline/>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3} className={classes.formSection}>
                                <Grid item xs={12} md={2} sx={{display: 'flex'}} alignItems={"center"}>
                                    <Typography variant="h5"
                                                sx={{fontSize: '1.6rem', fontWeight: '600'}}>Gender</Typography>
                                </Grid>
                                <Grid item xs={12} md={10}>
                                    <FormControl component="fieldset">
                                        <RadioGroup row aria-label="gender" name="sex"
                                                    value={values.sex}
                                                    onChange={handleChange}>
                                            <FormControlLabel value="F" control={<Radio disabled={disableSexRadioBtn} />} label="Female"/>
                                            <FormControlLabel value="M" control={<Radio disabled={disableSexRadioBtn} />} label="Male"/>
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Typography variant="h5" className={classes.sectionTitle}>Birth Date</Typography>
                            <Grid container spacing={3} className={classes.formSection}>
                                <Grid item xs={12} md={6}>
                                    <FormControl variant="filled" fullWidth>
                                        {!responsive ? (<DatePicker
                                            label="Birth Date"
                                            value={values.birthDate}
                                            onChange={(date) => setFieldValue('birthDate', date)}
                                            renderInput={(params) => <TextField {...params} variant="filled"/>}
                                            inputFormat="yyyy-MM-dd"
                                            onAccept={(date) => verifyAge(date)}
                                            disabled={disableInputs}
                                            mask="____-__-__"
                                        />) : (<MobileDatePicker
                                            label="Birth Date"
                                            value={values.birthDate}
                                            onChange={(date) => setFieldValue('birthDate', date)}
                                            renderInput={(params) => <TextField {...params} variant="filled"/>}
                                            inputFormat="yyyy-MM-dd"
                                            onAccept={(date) => verifyAge(date)}
                                            disabled={disableInputs}
                                            mask="____-__-__"
                                        />)}
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Typography variant="h5" className={classes.sectionTitle}>Passport</Typography>
                            <Grid container spacing={3} className={classes.formSection}>
                                <Grid item xs={12} md={6}>
                                    <FormControl variant="filled" fullWidth>
                                        <InputLabel htmlFor="passportNum">Passport Number</InputLabel>
                                        <FilledInput id="passportNum" name="passportNum"
                                                     value={values.passportNum}
                                                     disabled={disableInputs}
                                                     onChange={handleChange} disableUnderline/>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl variant="filled" fullWidth>
                                        <InputLabel htmlFor="passportNumVerification">Confirm Passport
                                            Number</InputLabel>
                                        <FilledInput id="passportNumVerification" name="passportNumVerification"
                                                     value={values.passportNumVerification}
                                                     onChange={handleChange}
                                                     disabled={disableInputs}
                                                     disableUnderline/>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Typography variant="h5" className={classes.sectionTitle}>Country</Typography>
                            <Grid container spacing={3} className={classes.formSection}>
                                <Grid item xs={12} md={6}>
                                    <FormControl variant="filled" fullWidth>
                                        <InputLabel id="citizenLabel">Select Country</InputLabel>
                                        <Select
                                            labelId="citizenLabel"
                                            id="citizenIso"
                                            name="citizenIso"
                                            label="Select Country"
                                            value={values.citizenIso}
                                            onChange={handleChange}
                                            disabled={disableInputs}
                                            disableUnderline
                                        >
                                            <MenuItem value={''}>Select Country</MenuItem>
                                            {countryList.map(country => (
                                                <MenuItem key={country.code}
                                                          value={country.code}>{country.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3} className={classes.formSection}>
                                <Grid item xs={12} md={6}>
                                    <Typography variant="h5" className={classes.sectionTitle}>Date of
                                        Issue</Typography>
                                    <FormControl variant="filled" fullWidth>
                                        {!responsive ? (<DatePicker
                                            label="YYYY-MM-DD"
                                            value={values.passportDateOfIssue}
                                            onChange={(date) => setFieldValue('passportDateOfIssue', date)}
                                            renderInput={(params) => <TextField {...params} variant="filled"/>}
                                            disabled={disableInputs}
                                            inputFormat="yyyy-MM-dd"
                                            mask="____-__-__"
                                        />) : (<MobileDatePicker
                                            label="YYYY-MM-DD"
                                            value={values.passportDateOfIssue}
                                            onChange={(date) => setFieldValue('passportDateOfIssue', date)}
                                            renderInput={(params) => <TextField {...params} variant="filled"/>}
                                            disabled={disableInputs}
                                            inputFormat="yyyy-MM-dd"
                                            mask="____-__-__"
                                        />)}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Typography variant="h5" className={classes.sectionTitle}>
                                        Expiration Date
                                    </Typography>
                                    <FormControl variant="filled" fullWidth>
                                        {!responsive ? (<DatePicker
                                            label="YYYY-MM-DD"
                                            value={values.passportExpiryDate}
                                            onChange={(date) => setFieldValue('passportExpiryDate', date)}
                                            renderInput={(params) => <TextField {...params} variant="filled"/>}
                                            disabled={disableInputs}
                                            inputFormat="yyyy-MM-dd"
                                            mask="____-__-__"
                                        />) : (<MobileDatePicker
                                            label="YYYY-MM-DD"
                                            value={values.passportExpiryDate}
                                            onChange={(date) => setFieldValue('passportExpiryDate', date)}
                                            renderInput={(params) => <TextField {...params} variant="filled"/>}
                                            disabled={disableInputs}
                                            inputFormat="yyyy-MM-dd"
                                            mask="____-__-__"
                                        />)}
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3} className={classes.formSection}>
                                <Grid item xs={12} md={6}>
                                    <Typography variant="h5" className={classes.sectionTitle}>
                                        Place of Issue
                                    </Typography>
                                    <FormControl variant="filled" fullWidth>
                                        <InputLabel id="passportPlaceOfIssueLabel">Select Country</InputLabel>
                                        <Select
                                            labelId="passportPlaceOfIssueLabel"
                                            id="passportPlaceOfIssue"
                                            name="passportPlaceOfIssue"
                                            label="Select Country"
                                            value={values.passportPlaceOfIssue}
                                            disabled={disableInputs}
                                            onChange={handleChange}
                                            disableUnderline
                                        >
                                            <MenuItem value={''}>Select Country</MenuItem>
                                            {countryList.map(country => (
                                                <MenuItem key={country.code}
                                                          value={country.code}>{country.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Typography variant="h5" className={classes.sectionTitle}>
                                        Place of Birth
                                    </Typography>
                                    <FormControl variant="filled" fullWidth>
                                        <InputLabel id="passportPlaceOfBirthLabel">Select Country</InputLabel>
                                        <Select
                                            labelId="passportPlaceOfBirthLabel"
                                            id="passportPlaceOfBirth"
                                            name="passportPlaceOfBirth"
                                            label="Select Country"
                                            value={values.passportPlaceOfBirth}
                                            onChange={handleChange}
                                            disabled={disableInputs}
                                            disableUnderline
                                        >
                                            <MenuItem value={''}>Select Country</MenuItem>
                                            {countryList.map(country => (
                                                <MenuItem key={country.code}
                                                          value={country.code}>{country.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Paper elevation={3}>
                                <Container className={classes.noteContainer}>
                                    <Typography style={{fontSize: '1.4rem'}}>
                                        <span style={{fontWeight: '600'}}>PLEASE NOTE:</span> guest name MUST
                                        match the
                                        passport
                                        of the person
                                        travelling.
                                    </Typography>
                                </Container>
                                <div>
                                    <img src={`${window['appBasename']}/images/Passport.jpg`}
                                         alt="Passport example image"/>
                                </div>
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container style={{marginTop: '30px'}} sx={{px: {xs: '1.6rem', lg: '0'}}}>
                    <Typography variant="h3" sx={{marginBottom: '20px'}}>
                        Contact Information<span style={{color: 'red'}}>*</span>
                    </Typography>
                    <Grid container spacing={3} className={classes.formSection}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h5" className={classes.sectionTitle}>Email</Typography>
                            <FormControl variant="filled" fullWidth>
                                <InputLabel htmlFor="email">Your Email</InputLabel>
                                <FilledInput id="email" name="email" value={values.email}
                                             disabled={disableInputs}
                                             onChange={handleChange} disableUnderline/>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h5" className={classes.sectionTitle}>Phone</Typography>
                            <FormControl variant="filled" fullWidth>
                                <InputLabel htmlFor="phone">Your Phone</InputLabel>
                                <FilledInput id="phone" name="phone" value={values.phone}
                                             disabled={disableInputs}
                                             onChange={handleChange} disableUnderline/>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Typography variant="h5" className={classes.sectionTitle}>Address</Typography>
                            <FormControl variant="filled" fullWidth>
                                <InputLabel htmlFor="address">Address 1</InputLabel>
                                <FilledInput id="address" name="address" value={values.address}
                                             disabled={disableInputs}
                                             onChange={handleChange} disableUnderline/>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl variant="filled" fullWidth>
                                <InputLabel htmlFor="address2">Address 2</InputLabel>
                                <FilledInput id="address2" name="address2" value={values.address2}
                                             disabled={disableInputs}
                                             onChange={handleChange} disableUnderline/>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h5" className={classes.sectionTitle}>City/District</Typography>
                            <FormControl variant="filled" fullWidth>
                                <InputLabel htmlFor="city">City</InputLabel>
                                <FilledInput id="city" name="city" value={values.city}
                                             disabled={disableInputs}
                                             onChange={handleChange} disableUnderline/>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h5"
                                        className={classes.sectionTitle}>State/Province</Typography>
                            <FormControl variant="filled" fullWidth>
                                <InputLabel htmlFor="state">State</InputLabel>
                                <FilledInput id="state" name="state" value={values.state}
                                             disabled={disableInputs}
                                             onChange={handleChange} disableUnderline/>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h5" className={classes.sectionTitle}>Postal
                                Code/ZIP</Typography>
                            <FormControl variant="filled" fullWidth>
                                <InputLabel htmlFor="postcode">Postal Code</InputLabel>
                                <FilledInput id="postcode" name="postcode"
                                             value={values.postcode} onChange={handleChange}
                                             disabled={disableInputs}
                                             disableUnderline/>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="h5" className={classes.sectionTitle}>Country</Typography>
                            <FormControl fullWidth variant="filled">
                                <InputLabel id="countryIsoLabel">Country</InputLabel>
                                <Select
                                    labelId="countryIsoLabel"
                                    id="countryIso"
                                    name="countryIso"
                                    label="Country"
                                    value={values.countryIso}
                                    onChange={handleChange}
                                    disabled={disableInputs}
                                    disableUnderline
                                >
                                    <MenuItem value={''}>Select Country</MenuItem>
                                    {countryList.map(country => (
                                        <MenuItem key={country.code} value={country.code}>{country.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Typography variant="h5" className={classes.sectionTitle}>Bed configuration</Typography>
                    <Grid container spacing={3} className={classes.formSection}>
                        <Grid item xs={12} md={6}>
                            <FormControl variant="filled" fullWidth>
                                <InputLabel id="bedsLabel">Select number of beds</InputLabel>
                                <Select
                                    labelId="bedsLabel"
                                    id="beds"
                                    name="beds"
                                    label="Select number of beds"
                                    value={values.beds}
                                    onChange={handleChange}
                                    disabled={disableInputs}
                                    disableUnderline
                                >
                                    <MenuItem value={''}>Select number of beds</MenuItem>
                                    <MenuItem value={'1'}>One shared Bed</MenuItem>
                                    <MenuItem value={'2'}>Two separate beds</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    {booking?.trip?.location?.tripTypeFk === 2 && (<>
                        <Grid container spacing={3} className={classes.formSection}>
                            <Grid item xs={12} md={6}>
                                <Typography variant="h5" className={classes.sectionTitle}>Hotel</Typography>
                                <FormControl variant="filled" fullWidth>
                                    <InputLabel htmlFor="flightInHotel">Hotel</InputLabel>
                                    <FilledInput id="flightInHotel" name="flightInHotel"
                                                 value={values.flightInHotel} onChange={handleChange}
                                                 disabled={disableInputs}
                                                 disableUnderline/>
                                </FormControl>
                            </Grid>
                        </Grid>
                        {/*<Grid container spacing={3} className={classes.formSection}>
                            <Grid item xs={12}>
                                <Typography variant="h5" className={classes.sectionTitle}>Flight In</Typography>
                                <Grid container spacing={3} className={classes.formSection}>
                                    <Grid item xs={12} md={6}>
                                        <FormControl variant="filled" fullWidth>
                                            {!responsive ? (<DatePicker
                                                label="Flight In Date"
                                                value={values.flightInDate}
                                                onChange={(date) => setFieldValue('flightInDate', date)}
                                                renderInput={(params) => <TextField {...params} variant="filled"/>}
                                                disabled={disableInputs}
                                                inputFormat="yyyy-MM-dd"
                                                mask="____-__-__"
                                            />) : (<MobileDatePicker
                                                label="Flight In Date"
                                                value={values.flightInDate}
                                                onChange={(date) => setFieldValue('flightInDate', date)}
                                                renderInput={(params) => <TextField {...params} variant="filled"/>}
                                                disabled={disableInputs}
                                                inputFormat="yyyy-MM-dd"
                                                mask="____-__-__"
                                            />)}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormControl variant="filled" fullWidth>
                                            <MobileTimePicker
                                                label="Flight In Time"
                                                value={values.flightInTime}
                                                onChange={(time) => setFieldValue('flightInTime', time)}
                                                disabled={disableInputs}
                                                renderInput={(params) => <TextField {...params} variant="filled"/>}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormControl variant="filled" fullWidth>
                                            <InputLabel htmlFor="flightInAirline">Flight In Airline</InputLabel>
                                            <FilledInput id="flightInAirline" name="flightInAirline"
                                                         value={values.flightInAirline} onChange={handleChange}
                                                         disabled={disableInputs}
                                                         disableUnderline/>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3} className={classes.formSection}>
                            <Grid item xs={12}>
                                <Typography variant="h5" className={classes.sectionTitle}>Flight Out</Typography>
                                <Grid container spacing={3} className={classes.formSection}>

                                    <Grid item xs={12} md={6}>
                                        <FormControl variant="filled" fullWidth>
                                            {!responsive ? (<DatePicker
                                                label="Flight Out Date"
                                                value={values.flightOutDate}
                                                onChange={(date) => setFieldValue('flightOutDate', date)}
                                                renderInput={(params) => <TextField {...params} variant="filled"/>}
                                                disabled={disableInputs}
                                                inputFormat="yyyy-MM-dd"
                                                mask="____-__-__"
                                            />) : (<MobileDatePicker
                                                label="Flight Out Date"
                                                value={values.flightOutDate}
                                                onChange={(date) => setFieldValue('flightOutDate', date)}
                                                renderInput={(params) => <TextField {...params} variant="filled"/>}
                                                disabled={disableInputs}
                                                inputFormat="yyyy-MM-dd"
                                                mask="____-__-__"
                                            />)}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormControl variant="filled" fullWidth>
                                            <MobileTimePicker
                                                label="Flight Out Time"
                                                value={values.flightOutTime}
                                                onChange={(time) => setFieldValue('flightOutTime', time)}
                                                disabled={disableInputs}
                                                renderInput={(params) => <TextField {...params} variant="filled"/>}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormControl variant="filled" fullWidth>
                                            <InputLabel htmlFor="flightOutAirline">Flight Out Airline</InputLabel>
                                            <FilledInput id="flightOutAirline" name="flightOutAirline"
                                                         value={values.flightOutAirline} onChange={handleChange}
                                                         disabled={disableInputs}
                                                         disableUnderline/>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>*/}
                    </>)}
                    {booking?.trip?.trip_class_info?.tripClassId === 4 && (<>
                            <Grid item xs={12}>
                                <Typography variant="h5" className={classes.sectionTitle}>
                                    Will you be meeting us in San Diego or Ensenada? *
                                </Typography>
                                <FormControl component="fieldset">
                                    <RadioGroup name="meetIn" value={values.meetIn}
                                                onChange={handleChange}>
                                        <Grid container spacing={1} marginTop={1}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={12}>
                                                    <FormControlLabel value={'San Diego'} control={<Radio/>}
                                                                      label="San Diego"/>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={1} marginTop={1}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={12}>
                                                    <FormControlLabel value={'Ensenada'} control={<Radio/>}
                                                                      label="Ensenada"/>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            {displayEnsenadaAlert && <Typography style={{marginTop: '20px'}}>
                                If you are meeting in Ensenada, you will need to <a href="https://www.inm.gob.mx/fmme/publico/en/solicitud.html" target="_blank">get an FMM Visa</a>.<br/>
                                Please go to the Customs office when entering Mexico to fill out an FMM Form.  You will need to have this form filled out and stamped by
                                immigration in order to board the boat. If you do not obtain a stamped FMM Visa, you will not be able to board the boat.
                            </Typography>}
                        </>
                    )}
                </Grid>
                <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '75px'}}>
                    <SecondaryButton onClick={() => history.goBack()} style={{margin: 0}}>Back</SecondaryButton>
                    <PrimaryButton style={{margin: 0}} type="submit">Next</PrimaryButton>
                </div>
            </LocalizationProvider>
        </Form>
    );
};

export default PassportAndContactForm;

PassportAndContactForm.propTypes = {
    booking: BookingPropTypes,
}